
import Phaser from 'phaser';
import GameManager from '~/scenes/GameManager';
import CardImage from './CardImage';
import { Label, Sizer } from 'phaser3-rex-plugins/templates/ui/ui-components';
import RoundRectangle from 'phaser3-rex-plugins/plugins/roundrectanglecanvas';
import TextureKeys from '~/consts/TextureKeys';
import { Card } from './Card';
import main from '~/main';
import { GlobalConfig } from '~/config/GlobalConfig';
import IconKey from '~/consts/IconKey';

export default class Ingameui
{
    gameManager :GameManager
    scene:Phaser.Scene
    boardCards : CardImage[] = [];
    playerCard : CardImage[] = [];
    Ai1Cards : CardImage[] = [];
    Ai2Cards : CardImage[] = [];
    Ai3Cards : CardImage[] = [];
    geoffCon;
    kateCon;
    jimCon;

    constructor(manager:GameManager)
    {
        this.gameManager=manager;
        this.scene=manager;
    }
    
    public SetupBoard()
    {


        this.playerCard=[];
        this.Ai1Cards=[];
        this.Ai2Cards=[];
        this.Ai3Cards=[];

        this.BoardCardUi()
        this.AICardUi()
        this.PlayerUi()
        this.setAiCard()
        this.showPlayerCard()
    }

    showPlayerCard()
    {
        this.playerCard.forEach(element => {
            element.foldCard()
        });
    }
    setAiCard()
    {
        this.Ai1Cards.forEach(element => {
            element.setCard(TextureKeys.AI1)
        });
        this.Ai2Cards.forEach(element => {
            element.setCard(TextureKeys.AI2)
        });
        this.Ai3Cards.forEach(element => {
            element.setCard(TextureKeys.AI3)
        });
    }

    BoardCardUi()
    {
        const playerSizer = new Sizer(this.scene, {
            orientation: 'horizontal',
            space: { left: 10, right: 10, item: 10 },
            x:468,
            y:287

        }).setOrigin(0.5,0.5);
        const bg=this.scene.add.image(468,287,TextureKeys.BoardCardBG).setOrigin(0,0)
        // const background = new RoundRectangle(this.scene, playerSizer.x, playerSizer.y, playerSizer.width, playerSizer.height, 50
        //     , 0x2e2d2d)
        // this.scene.add.existing(background)
        this.AddGrid(this.gameManager.tableCards,this.boardCards,playerSizer,0.5)
        playerSizer.layout();
        playerSizer.setPosition(playerSizer.x+bg.width/2,playerSizer.y+bg.height/2)
        // background.setPosition(playerSizer.x, playerSizer.y);
        // background.setDisplaySize(playerSizer.width, playerSizer.height);

    }
    
    AICardUi()
    {

        // maim
        // const mainSizer = new Sizer(this.scene, {
        //     orientation: 'horizontal',
        //     space: { left: 10, right: 10, item: 10 },
        //     x:20,
        //     y:60 

        // }).setOrigin(0.5,0);
        const bgAi1=this.scene.add.image(121,420,TextureKeys.AI1BG).setOrigin(0,0)
        this.geoffCon=this.AiCard(this.gameManager.geoffCards,this.Ai1Cards,"Geoff")
        this.geoffCon.setPosition(bgAi1.x,bgAi1.y-100)
        const bgAi2=this.scene.add.image(800,120,TextureKeys.AI2BG).setOrigin(0,0)
        this.jimCon=this.AiCard(this.gameManager.jimCards,this.Ai2Cards,"Jim")
        this.jimCon.setPosition(bgAi2.x,bgAi2.y-100)
        const bgAi3=this.scene.add.image(1480,420,TextureKeys.AI3BG).setOrigin(0,0)
        this.kateCon=this.AiCard(this.gameManager.kateCards,this.Ai3Cards,"Kate")
        // bgAi3.setPosition(this.scene.cameras.main.width - bgAi3.width-121,bgAi3.y)
        this.kateCon.setPosition(bgAi3.x,bgAi3.y-100)
        // const container = this.scene.add.container(121, 409, [bgAi1, vert1]);
        // container.setSize(bgAi1.width, bgAi1.height)
        // const vert2=this.AiCard(this.gameManager.jimCards,this.Ai2Cards,"Jim")
        // const vert3=this.AiCard(this.gameManager.kateCards,this.Ai3Cards,"Kate")
       
        // mainSizer.add(vert1, { align: 'center', padding: { left: 5, right: 5, top: 5, bottom: 5 } });
        // mainSizer.add(vert2, { align: 'center', padding: { left: 5, right: 5, top: 5, bottom: 5 } });
        // mainSizer.add(vert3, { align: 'center', padding: { left: 5, right: 5, top: 5, bottom: 5 } });
        // mainSizer.layout();
        // mainSizer.setPosition(this.scene.scale.width/2,mainSizer.y)
    }

    AiCard(gameCard : Card[], holder : CardImage[], name:string): Sizer
    {
        // ai 1
        const vert1= new Sizer(this.scene, {
            orientation: 'vertical',
            space: { left: 10, right: 10, item: 10 },
            x:20,
            y:100+this.scene.scale.height/2 

        }).setOrigin(0,0);
        const nametxt = this.scene.add.text(0,0,name,
            {
                fontSize: '24px',
                fontStyle:'bold',
                fontFamily: GlobalConfig.FONT_FAMILY,
                align: 'center',
                color: "#" + GlobalConfig.FONT_COLOR.toString(16)
            })
            const handTxt = this.scene.add.text(0,0,'',
                {
                    fontSize: '24px',
                    fontStyle:'bold',
                    fontFamily: GlobalConfig.FONT_FAMILY,
                    align: 'center',
                    color: "#" + GlobalConfig.FONT_COLOR.toString(16)
                }).setOrigin(0.5,0.5)
        const playerSizer = new Sizer(this.scene, {
            orientation: 'horizontal',
            space: { left: 10, right: 10, item: 10 },
            x:20,
            y:100+this.scene.scale.height/2 

        }).setOrigin(0,0);
        this.AddGrid(gameCard,holder,playerSizer,0.35)
        playerSizer.layout();
        vert1.add(playerSizer, { align: 'center', padding: { left: 5, right: 5} });
        vert1.add(nametxt, { align: 'center', padding: { top:20 } });
        vert1.add(handTxt, { align: 'center', padding: { top:20 } });
        vert1.layout();
        return vert1;
    }

    AddGrid(gameCard : Card[], holder : CardImage[],sizer:Sizer,scale: number) 
    {
        for(var i=0;i<gameCard.length;i++)
            {
                const playerImage = new CardImage(this.scene,75,100,1,1,TextureKeys.CardBG
                    ,gameCard[i].cardImg).setScale(scale);
                holder.push(playerImage)
                sizer.add(playerImage, { align: 'center', padding: { left: 5, right: 5, top: 5, bottom: 5 } });
            }
    }

    PlayerUi()
    {
        const playerSizer = new Sizer(this.scene, {
            orientation: 'horizontal',
            space: { left: 10, right: 10, item: 10 },
            x:831,
            y:638 

        }).setOrigin(0,0);
        this.AddGrid(this.gameManager.playerCards,this.playerCard,playerSizer,0.4)
        playerSizer.layout()
    }
    
}